import { IconSpec } from "@omegagrid/core";
import { Project, Query, Resource } from "@reporting/rp-types/ext";

export type FileExtensionInfo = {
	language: string;
	icon?: IconSpec|string;
};

export const projectVersions = ['3', '2'];

const unknownFileExtensionInfo: FileExtensionInfo = {
	language: 'plain/text',
	icon: {icon:'file-code', color: '#888'}
};

const fileExtensionMap: [string[], FileExtensionInfo][] = [
	[['js', 'ts', 'tsx', 'jsx'], { language: 'javascript', icon: {icon: ['fab', 'square-js'], color: '#f7df1e'} }],
	[['sheet'], { language: 'json', icon: {icon: 'file-spreadsheet', color: '#0aa073'} }],
	[['json'], { language: 'json', icon: {icon: 'brackets-curly', color: '#ffa500'} }],
	[['html', 'htm'], { language: 'html', icon: {icon: ['fab', 'html5'], color: '#e34f26'} }],
	[['css'], { language: 'css', icon: {icon: ['fab', 'css'], color: '#1572b6'} }],
	[['md'], { language: 'markdown', icon: {icon: 'markdown', color: '#083fa1'} }],
	[['xml'], { language: 'xml', icon: {icon: 'code', color: '#ff6600'} }],
	[['yml', 'yaml'], { language: 'yaml', icon: {icon: 'file-code', color: '#cc0000'} }],
	[['sql'], { language: 'sql', icon: {icon: ['fas', 'database'], color: '#336791'} }]
];


export function getFileExtensionInfo(filename: string): FileExtensionInfo {
	const parts = filename.split('.');
	if (parts.length == 1) return { ...unknownFileExtensionInfo };

	const ext = parts.pop().toLowerCase();

	for (const [exts, info] of fileExtensionMap) {
		if (exts.includes(ext)) return { ...info };
	}

	return { ...unknownFileExtensionInfo };
}

export function formatProject(project: Project) {
	return `#${project.id_custom_page} ${project.name}`;
}

export function formatQuery(query: Query) {
	return `#${query.id_thread} ${query.description}`;
}

export function formatResource(resource: Resource) {
	return `#${resource.id_custom_resource} ${resource.name}`;
}

export function requiresSandbox(resource: Resource) {
	return /\.html?$/i.test(resource.name);
}

export function getEditorComponentType(filename: string): 'htmlEditor'|'sheetEditor'|'file' {
	if (/\.html?$/i.test(filename)) return 'htmlEditor';
	if (/\.sheet$/i.test(filename)) return 'sheetEditor';
	return 'file';
}

export function sqlTypeToJsType(sqlType: string): 'string' | 'number' | 'boolean' {
	if (/int|float|double|decimal|numeric/i.test(sqlType)) return 'number';
	if (/bit/i.test(sqlType)) return 'boolean';
	return 'string';
}

export function parseSqlTableType(dataType: string): {name: string, type: 'string' | 'number' | 'boolean'}[] {
	const match = dataType.trim().match(/table\s*\((.+)\)/i);
	if (!match) return [];
	return match[1].split(',').map(s => {
		const [col, type] = s.trim().replace(/\s+/g, ' ').split(' ');
		return { name: col.replace(/^\[(.+)\]$/, '$1').toLowerCase(), type: sqlTypeToJsType(type) };
	});
}
